// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1735":"6fe55702054a9c40","1869":"25d5079287f58714"}[chunkId] + ".css";
};